<template>
	<b-row>
		<b-col cols="12">
			<b-card>
				<div slot="header">
					{{ $t(`kirim.title`) }}
					<div class="card-header-actions">
						<vs-dropdown vs-custom-content vs-trigger-click>
							<b-link href.prevent class="card-header-action btn-setting" style="font-size: 15px">
								<i class="fa fa-th"></i>
							</b-link>
							<vs-dropdown-menu class="columns-dropdown">
								<visible-columns :default-fields="fields" @result="columnListener"></visible-columns>
							</vs-dropdown-menu>
						</vs-dropdown>
					</div>
				</div>
				<b-card-body>
					<div class="table-wrapper">
						<b-table class="generalTableClass mb-2 poin" id="incomeTable" :items="items"
							:fields="computedFields" hover="hover" striped="striped" bordered="bordered" responsive
							show-empty @row-clicked="rowClickprixod">
							<!-- EMPTY SLOT FOR TABLE -->
							<template slot="empty" slot-scope="scope">
								<h4>{{ $t('empty') }}</h4>
							</template>
							<!-- EMPTY SLOT FOR TABLE -->
							<template slot="id" slot-scope="data">
								<strong>{{ paginate(data.index, search.page, search.limit) }}</strong>
							</template>
							<template slot="documentStatus" slot-scope="data">
								{{ data.value }}
							</template>
							<template slot="regNumber" slot-scope="data">
								{{ data.value }}
							</template>
							<template slot="reason" slot-scope="data">
								<div class="no-wrap">
									{{ data.value }}
								</div>
							</template>
							<template slot="comment" slot-scope="data">
								<div class="no-wrap">
									{{ data.value }}
								</div>
							</template>
							<template slot="regDate" slot-scope="data">
								{{ formatDate(data.value) }}
							</template>
							<template slot="actions" slot-scope="data">
								<div class="text-dark">
									<b-link :to="`/warehouse-management/income-view/view/${data.item.id}`" class="mr-2">
										<i class="fa fa-eye" style="font-size: 18px" />
									</b-link>
								</div>
							</template>
						</b-table>
						<nav class="text-center">
							<b-pagination-new background :total="total" layout="prev, pager, next"
								:page-size="search.limit" :current-page.sync="search.page"
								@current-change="getItems($event)" />
						</nav>
						<div v-if="loading" class="spinner-wrapper">
							<b-spinner variant="primary"></b-spinner>
						</div>
					</div>
				</b-card-body>
			</b-card>
		</b-col>
	</b-row>
</template>

<script>
import VisibleColumns from "../../warehouse-management/goods/blocks/VisibleColumns";
import ReferencesService from "../../../services/references.sevice";
import WhDocument from "../../../services/wh-document.service";
import { Pagination } from 'element-ui'
import moment from 'moment'

export default {
	name: "Index",
	components: {
		VisibleColumns,
		"b-pagination-new": Pagination
	},
	data() {
		return {
			fields: [
				{ key: 'actions', label: 'incomes.actions', 'class': 'min-60', visible: true, changebale: false },
				{ key: 'id', label: 'ID', sortable: true, visible: true, 'class': 'min-60 text-center', changebale: false },
				{ key: 'regDate', label: 'incomes.date', visible: true, 'class': 'min-80', sortable: true, changebale: true },
				{ key: 'documentStatus', label: 'promo-to-product.status', visible: true, 'class': 'min-100', sortable: true, changebale: true },
				{ key: 'regNumber', label: 'incomes.name', visible: true, 'class': 'min-200', sortable: true, changebale: true },
				{ key: 'docCreatedBy', label: 'Создатель', visible: false, 'class': 'min-200', sortable: true, changebale: true },
				{ key: 'docCreatedDate', label: 'Дата создания', visible: false, 'class': 'min-200', sortable: true, changebale: true },
				{ key: 'docLastModifiedBy', label: 'Обнoвлён', visible: true, 'class': 'min-200', sortable: true, changebale: true },
				{ key: 'docChangedDate', label: 'Дата обновления', visible: true, 'class': 'min-200', sortable: true, changebale: true },
				{ key: 'contragentName', label: 'incomes.counteragent', visible: true, 'class': 'min-150', sortable: true, changebale: true },
				{ key: 'reason', label: 'Сч/фактура поставщика', visible: true, sortable: true, 'class': 'min-200', changebale: true },
				{ key: 'numberGTD', label: 'Номер ГТД', visible: true, sortable: true, 'class': 'min-200', changebale: true },
				{ key: 'extraCosts', label: 'sidebar.warehouse-management.extra-cost', class: 'min-150', visible: true, sortable: true, changebale: true },
				{ key: 'toDepartmentName', label: 'incomes.department', visible: false, sortable: true, class: 'min-150', changebale: true },
				{ key: 'comment', label: 'comment', 'class': 'min-200', visible: true, sortable: true, changebale: true },
				{ key: 'responsibleName', label: 'incomes.responsible', visible: false, sortable: true, changebale: true },
				{ key: 'fromEmployeeName', label: 'incomes.from-employee', visible: false, 'class': 'min-150', sortable: true, changebale: true },
				{ key: 'toEmployeeName', label: 'incomes.to-employee', visible: false, 'class': 'min-150', sortable: true, changebale: true }
			],
			search: {
				page: 1,
				limit: 20,
			},
			total: 0,
			items: [],
			loading: true,
		}
	},
	watch: {
	},
	computed: {
		computedFields() {
			return this.filterColumns(this.fields)
		},
	},
	methods: {
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		formatDate(date) {
			const split = date.split(' ');
			date = split[0];
			const revers = date.split('-');
			date = revers[2] + '-' + revers[1] + '-' + revers[0] + 'T00:00:00';
			return moment(String(date)).format('DD-MM-YYYY')
		},
		rowClickprixod($event) {
			this.$router.push(`/warehouse-management/income-view/view/${$event.id}`)
		},
		filterColumns(columns = []) {
			return columns.filter(column => {
				if (column.visible) {
					column.label = this.$t(column.label);
					return column
				}
			})
		},
		columnListener($event) {
			setTimeout(() => {
				this.fields = $event
			}, 200)
		},
		getItems() {
			this.loading = true
			WhDocument.warehouseDocumentListIncomeDeleted(this.search).then(res => {
				if (res.data.items && res.data.items.length > 0) {
					this.items = res.data.items
					this.total = res.data.total
				} else {
					this.items = []
					this.total = 0
				}
				this.loading = false
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
				this.loading = false
			})
		},
	},
	created() {
		this.getItems()
	}
}
</script>

<style scoped>
a {
	color: black !important;
}

.no-wrap {
	white-space: nowrap;
}

.poin {
	cursor: pointer;
}

.table-wrapper {
	position: relative;
	padding: 5px;
}

.spinner-wrapper {
	position: absolute;
	background: rgba(32, 28, 32, 0.49);
	left: 0;
	right: 0;
	text-align: center;
	top: 0;
	bottom: 0;
	padding-top: 35px;
	z-index: 5;
}
</style>
